import React from "react";
import { styled } from "@mui/material/styles";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const PREFIX = "ProgressLine";

const classes = {
  bar: `${PREFIX}-bar`,
  root: `${PREFIX}-root`,
  progressColor: `${PREFIX}-progressColor`,
};

const Root = styled("div")(({ theme }) => ({
  [`&.${classes.root}`]: {
    width: "100%",
  },

  [`&.${classes.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.primary.main,
  },

  [`& .${classes.progressColor}`]: {
    backgroundColor: "#ffffff",
    opacity: "0.9",
  },
}));

export function LinearProgressWithLabel(props) {
  // Déterminer la couleur en fonction de la valeur
  const getProgressColor = (value) => {
    if (value === 100) return "#4A90E2"; // Bleu pastel
    if (value >= 51) return "#7ED321"; // Vert pastel
    if (value >= 21) return "#F5A623"; // Orange pastel
    return "#D0021B"; // Rouge pastel
  };

  // Si displayMode est "dot", afficher une pastille au lieu d'une barre de progression
  if (props.displayMode === "dot") {
    return (
      <Box display="flex" alignItems="center" justifyContent="center">
        <Box
          sx={{
            width: 16,
            height: 16,
            borderRadius: "50%",
            backgroundColor: getProgressColor(props.value),
            marginRight: 1,
          }}
        />
        <Typography
          variant="caption"
          color="textSecondary"
          sx={{ marginTop: "0.2rem" }}
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    );
  }

  // Sinon, afficher la barre de progression standard
  return (
    <Root>
      <Box display="flex" alignItems="center">
        <Box width="100%" mr={1}>
          {props.isgltfloader === "true" ? (
            <LinearProgress
              variant="determinate"
              color="primary"
              {...props}
              sx={{
                "& .MuiLinearProgress-bar": {
                  backgroundColor: getProgressColor(props.value),
                },
              }}
            />
          ) : (
            <BorderLinearProgress
              variant="determinate"
              color="primary"
              {...props}
              sx={{
                "& .MuiLinearProgress-bar": {
                  backgroundColor: getProgressColor(props.value),
                },
              }}
            />
          )}
        </Box>
        {props.showLabel !== false && (
          <Box minWidth={35}>
            <Typography variant="body2" color="textSecondary">{`${Math.round(
              props.value
            )}%`}</Typography>
          </Box>
        )}
      </Box>
    </Root>
  );
}

export default function LinearWithValueLabel(props) {
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    setProgress(props.step >= 10 ? progress + 5 : props.step * 10);
  }, [props.step]);

  return (
    <Root>
      <div className={classes.root}>
        <LinearProgressWithLabel value={progress} />
      </div>
    </Root>
  );
}

export const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
    ...theme.applyStyles("dark", {
      backgroundColor: theme.palette.grey[800],
    }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: "#1a90ff",
    ...theme.applyStyles("dark", {
      backgroundColor: "#d3Af5F",
    }),
  },
}));
